import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useAppTheme } from '@/context/ThemeContext';
import { useState, useEffect } from 'react';

type BusinessLayoutRouteProps = {
  children: React.ReactNode;
  title: string;
};

export default function BusinessLayoutRoute({ children, title }: BusinessLayoutRouteProps) {
  const { theme, themeConfig, setTheme } = useAppTheme();
  const [isMinimized, setIsMinimized] = useState(localStorage.getItem('sidebarMinimized') === 'true');
  
  // Save sidebar state to localStorage
  useEffect(() => {
    localStorage.setItem('sidebarMinimized', isMinimized.toString());
  }, [isMinimized]);
  
  const toggleSidebar = () => {
    setIsMinimized(!isMinimized);
  };
  
  const toggleTheme = () => {
    const newTheme = theme === 'charity' ? 'business' : 'charity';
    setTheme(newTheme);
  };
  
  // Sidebar width calculation
  const SIDEBAR_EXPANDED_WIDTH = 240;
  const SIDEBAR_MINIMIZED_WIDTH = 64;
  const sidebarWidth = isMinimized ? SIDEBAR_MINIMIZED_WIDTH : SIDEBAR_EXPANDED_WIDTH;
  
  // Use the Layout component to ensure consistent sidebar rendering
  // This way we're delegating sidebar rendering to the main Layout component
  // which has been updated to handle nested layouts properly
  return (
    <div className="flex h-full w-full overflow-hidden min-w-[1024px]" style={{ backgroundColor: themeConfig.surface }}>
      {/* Business Sidebar positioned at the far left */}
      <Sidebar 
        isOpen={true} 
        isMinimized={isMinimized} 
        onClose={() => {}} 
        theme={theme}
      />
      
      {/* Main Content */}
      <div className="flex flex-col flex-1 w-full h-full transition-all duration-300 ease-in-out">
        <Header 
          title={title} 
          onMenuClick={toggleSidebar}
          onThemeToggle={toggleTheme}
          isMinimized={isMinimized}
        />
        
        {/* Main Content Area */}
        <main 
          className="flex-1 w-full h-full overflow-auto" 
          style={{ 
            backgroundColor: themeConfig.surface, 
          }}
        >
          <div 
            className="w-full py-4 mx-auto"
            style={{ 
              paddingLeft: `calc(${sidebarWidth}px + 20px)`, 
              paddingRight: '20px' 
            }}
          >
            
            {/* Page Content */}
            <div className="pb-4">
              {children}
            </div>
          </div>
        </main>
        
        {/* Footer */}
        <footer className="w-full bg-white shadow-md py-3 px-4 text-center text-sm text-gray-600">
          <p>© {new Date().getFullYear()} Catch of the Day. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}
